import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import PasswordChangeDialog from './PasswordChangeDialog';

const PasswordChangeWrapper: React.FC = () => {
    const {
        isPasswordChangeModalOpen,
        closePasswordChangeModal,
        user,
        checkPasswordStatus
    } = useAuth();

    const handlePasswordChangeSuccess = async () => {
        // Close the modal and refresh user status
        closePasswordChangeModal();

        // Optionally, refresh the user profile to get updated force_password_change status
        await checkPasswordStatus();
    };

    const handleClose = () => {
        // For first login scenarios, we might not allow closing until password is changed
        // This is handled within the PasswordChangeDialog component
        closePasswordChangeModal();
    };

    return (
        <PasswordChangeDialog
            open={isPasswordChangeModalOpen}
            onClose={handleClose}
            onSuccess={handlePasswordChangeSuccess}
            userEmail={user?.email}
            isFirstLogin={true} // Assuming all forced password changes are first login scenarios
        />
    );
};

export default PasswordChangeWrapper;
